import React, { useState, useImperativeHandle, forwardRef } from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import DateTimePicker from "@react-native-community/datetimepicker";
import { format } from "date-fns";
import color from "@constants/color";

const SingleDatePicker = forwardRef((props, ref) => {
  const { date: dateFromProps, handleDateChanged } = props;
  const [date, setDate] = useState(dateFromProps || new Date());
  const [showPicker, setShowPicker] = useState(false);

  const {
    width = "100%",
    title = "",
    datePlaceholder = "",
    titleColor = "rgba(0, 0, 0, .8)",
    minimumDate = "",
    maximumDate = "",
  } = props;

  const togglePicker = () => {
    setShowPicker(true);
  };

  const setNewDate = (e, newDate) => {
    setShowPicker(false);
    setDate(newDate || date);
    handleDateChanged(newDate || date);
  };

  useImperativeHandle(ref, () => ({
    getDate: () => {
      return date;
    },
  }));

  const setFormattedDateForView = () => {
    return format(new Date(date), "dd/MM/yyyy");
  };

  return (
    <>
      <View style={{ width }}>
        <TouchableOpacity
          style={[
            styles.beLikeRow,
            {
              paddingVertical: 8,
              paddingHorizontal: 15,
              borderRadius: 4,
              justifyContent: "center",
              backgroundColor: "rgba(243, 243, 243, 1)",
            },
          ]}
          onPress={togglePicker}
        >
          <Text
            variant="caption_2"
            style={{ color: color.mediumBlacklightBlack }}
          >
            {date ? setFormattedDateForView() : datePlaceholder}
          </Text>
        </TouchableOpacity>
        {title ? (
          <Text variant="caption_2" style={{ color: titleColor, marginTop: 4 }}>
            {title}
          </Text>
        ) : null}
      </View>
      {showPicker ? (
        <DateTimePicker
          value={date}
          mode="date"
          display="default"
          onChange={(e, d) => setNewDate(e, d)}
          minimumDate={minimumDate || new Date(1950, 0, 1)}
          maximumDate={maximumDate || undefined}
        />
      ) : null}
    </>
  );
});

const styles = StyleSheet.create({
  beLikeRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  primaryText: {
    color: "rgba(0, 0, 0, 0.36)",
  },
});

export default SingleDatePicker;
